module.exports = __webpack_public_path__ + "media/src/fonts/icomoon-154e7b163a1b73b4a4bb3f83cff1305b.ttf";